import React from 'react';
import PropTypes from 'prop-types';
import { BoldMatchedText } from '@src/components/core/core-component-imports';

/**
 * Renders a radio input option.
 */
const RadioOption = ({ id, name, textToBold, disabled, checked, clickHandler }) => {
  return (
    <label htmlFor={id}>
      <input
        id={id}
        type='radio'
        name='filter'
        value={name}
        disabled={disabled}
        checked={checked}
        onClick={clickHandler}
        readOnly
      />
      <p className='filter-name'>
        <BoldMatchedText text={name} textToBold={textToBold} />
      </p>
    </label>
  );
};

RadioOption.propTypes = {
  /**
   * the id for the radio input option
   */
  id: PropTypes.string.isRequired,
  /**
   * the name to display for the radio input option
   */
  name: PropTypes.string.isRequired,
  /**
   * the text to show in bolded font, when matched
   */
  textToBold: PropTypes.string,
  /**
   * whether or not the radio input is checked
   */
  checked: PropTypes.bool.isRequired,
  /**
   * whether or not the radio input option can be selected
   */
  disabled: PropTypes.bool,
  /**
   * the callback function for when the radio input option is clicked
   */
  clickHandler: PropTypes.func.isRequired,
};

export default RadioOption;
